import { Badge } from './ui/Badge';

type RawStatus =
  | 'idle'
  | 'queued'
  | 'running'
  | 'completed'
  | 'failed'
  | 'halted_manual_edits'
  | 'awaiting_plan_decision'
  | 'paused_resumable'
  | undefined
  | null;

interface Props {
  status: RawStatus;
  hasLiveUrl?: boolean;
}

export function StatusBadge({ status, hasLiveUrl }: Props) {
  if (status === 'completed') {
    return (
      <Badge tone="green" dot>
        {hasLiveUrl ? 'Live' : 'Built'}
      </Badge>
    );
  }
  if (status === 'running') {
    return (
      <Badge tone="blue" dot>
        Generating
      </Badge>
    );
  }
  if (status === 'queued') {
    return (
      <Badge tone="amber" dot>
        Queued
      </Badge>
    );
  }
  if (status === 'failed') {
    return (
      <Badge tone="red" dot>
        Failed
      </Badge>
    );
  }
  if (status === 'halted_manual_edits' || status === 'paused_resumable') {
    return <Badge tone="amber">Paused</Badge>;
  }
  if (status === 'awaiting_plan_decision') {
    return <Badge tone="amber">Needs review</Badge>;
  }
  return <Badge tone="neutral">Idle</Badge>;
}
